module.exports = __webpack_public_path__ + "img/social1.15f9c044.png";